import { NgModule } from '@angular/core';
import { CommonModule } from '@app/common.module';
import { RadioGroupStretcherComponent } from './radio-group-stretcher.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    RadioGroupStretcherComponent,
  ],
  exports: [
    RadioGroupStretcherComponent,
  ],
})
export class RadioGroupStretcherModule {}
